import React, { Component } from 'react';

import SessionStore from "../stores/SessionStore";

class OrganizationForm extends Component {
  constructor() {
    super();

    this.state = {
      organization: {},
      customServer:SessionStore.customServer,
      showCanHaveGateways: SessionStore.isAdmin(),
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      organization: nextProps.organization,
    });
  }

  componentWillMount() {
    SessionStore.on("change", () => {
      this.setState({
        customServer: SessionStore.customServer,
        showCanHaveGateways: SessionStore.isAdmin(),
      });
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.onSubmit(this.state.organization);
  }

  onChange(field, e) {
    let organization = this.state.organization;
    if (e.target.type === "checkbox") {
      organization[field] = e.target.checked; 
    } else {
      organization[field] = e.target.value;
    }
    this.setState({
      organization: organization,
      customServer: SessionStore.customServer,
      showCanHaveGateways: SessionStore.isAdmin(),
    });
  }

  render() {
    return(
      <form onSubmit={this.handleSubmit}>
        <div className="form-group">
          <label className="control-label" htmlFor="name">Organization name</label>
          <input className="form-control" id="name" type="text" placeholder="e.g. my-organization" pattern="([^/]+)" required value={this.state.organization.name || ''} onChange={this.onChange.bind(this, 'name')} />
          <p className="help-block">
            The name may only contain words, numbers and dashes. 
          </p>
        </div>
        <div className="form-group">
          <label className="control-label" htmlFor="displayName">Display name</label>
          <input className="form-control" id="displayName" type="text" placeholder="My Organization" required value={this.state.organization.displayName || ''} onChange={this.onChange.bind(this, 'displayName')} />
        </div>
        <div className={"form-group " + (this.state.showCanHaveGateways ? '' : 'hidden')}>
          <label className="control-label">Can have gateways</label>
          <div className="checkbox">
            <label>
              <input type="checkbox" name="canHaveGateways" id="canHaveGateways" checked={this.state.organization.canHaveGateways} onChange={this.onChange.bind(this, 'canHaveGateways')} /> Can have gateways 
            </label>
          </div>
          <p className="help-block">
            When checked, it means that organization administrators are able to add their own gateways to the network. 
            Note that the usage of the gateways is not limited to this organization.
          </p>
        </div>

        <div className={(this.state.customServer === "mhs" || this.state.customServer === "undefined")  ? "hidden" :"form-group"}>
          <label className="control-label" htmlFor="mqttUser">MQTT username at mydevices.com</label>
          <input className="form-control" id="mqttUser" type="text" placeholder="12345678-1234-1234-1234-123456789ab" value={this.state.organization.mqttName || ''} onChange={this.onChange.bind(this, 'mqttName')} />
          <p className="help-block">
            It's the MQTT username at mydevices.com, not the account at mydevices.com.
            If you input the correct MQTT username and password, and input correct client id in node setting, then you will get the data in phone app 'Cayenne'.
          </p>
        </div>
        <div className={(this.state.customServer === "mhs" || this.state.customServer === "undefined")  ? "hidden" :"form-group"}>
          <label className="control-label" htmlFor="mqttPassword">MQTT password at mydevices.com</label>
          <input className="form-control" id="mqttPassword" type="text" placeholder="MQTT password" value={this.state.organization.mqttPassword || ''} onChange={this.onChange.bind(this, 'mqttPassword')} />
          <p className="help-block">
            The MQTT password at mydevices.com. Not the account password at mydevices.com.
          </p>
        </div>
        <hr />
        <button type="submit" className="btn btn-primary pull-right">Submit</button>
      </form>
    );
  }
}

export default OrganizationForm;



// WEBPACK FOOTER //
// ./src/components/OrganizationForm.js